import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ContactModal } from "./ContactModal";
import { SuggestPriceModal } from "../SuggestPrice";
import { MobileLegalNoticeSectionModal } from "./MobileLegalNoticeSectionModal";
import { MultiInquiryModal } from "./MultiInquiryModal";
import { PersonalDataModal } from "./PersonalDataModal";
export const ContactingModalWrapper = () => {
    return (_jsxs(_Fragment, { children: [_jsx(ContactModal, {}), _jsx(SuggestPriceModal, {}), _jsx(MultiInquiryModal, {}), _jsx(PersonalDataModal, {}), _jsx(MobileLegalNoticeSectionModal, {})] }));
};
